import { render } from "./SettingsOverlay.vue?vue&type=template&id=7154b87f&scoped=true"
import script from "./SettingsOverlay.vue?vue&type=script&lang=js"
export * from "./SettingsOverlay.vue?vue&type=script&lang=js"

import "./SettingsOverlay.vue?vue&type=style&index=0&id=7154b87f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7154b87f"]])

export default __exports__